import Calendar from "assets/svgs/Calendar"
import CheckBox from "assets/svgs/CheckBox"
import ChevronDown1 from "assets/svgs/ChevronDown1"
import ChevronUp from "assets/svgs/ChevronUp"
import Clock from "assets/svgs/Clock"
import GoldMedal from "assets/svgs/GoldMedal"
import LineChart from "assets/svgs/LineChart"
import Wallet from "assets/svgs/Wallet"
import { InfoButton, LineChartIcon } from "core/constants/svgs"
import { CustomScroll } from "react-custom-scroll"

const DetailedProgressDataView = ({
  detailedProgress,
  activeButton,
  month,
  year,
  showFirst6Months,
  overallProgress,
  isOverallReport,
  showAttendance,
  setShowAttendance,
}: {
  detailedProgress: any[]
  activeButton: string
  month: number | null
  year: number
  showFirst6Months: boolean
  overallProgress: any
  isOverallReport: any
  showAttendance: number
  setShowAttendance: React.Dispatch<React.SetStateAction<number>>
}) => {
  return (
    <div className="w-[350px] p-4 rounded-lg shadow-[-1px_1px_3px_0px_rgba(34,41,48,0.15)] border border-[#d3d3d3]">
      <div className="flex justify-between items-bottom mb-2">
        <div className="text-[#1b3473] text-base font-semibold">{activeButton}</div>
        <div className="w-6 h-6 p-1 bg-[#f8f8f8] rounded justify-center items-center inline-flex overflow-hidden">
          <div>
            <LineChartIcon className="w-4 h-4" />
          </div>
        </div>
      </div>
      <CustomScroll heightRelativeToParent="100%" className="w-[calc(100%+0.75rem)] max-h-[calc(100%-1.25rem)]">
        <div className="flex w-[calc(100%-0.75rem)] flex-wrap gap-2 py-2">
          {!isOverallReport ? (
            detailedProgress.map((item: any, index: any) =>
              activeButton === "Classes Scheduled" || activeButton === "Problems Solving" ? (
                <div className="w-[calc(33%-5px)] p-2 rounded-lg border border-[#d3d3d3] flex flex-col gap-1">
                  <div className="self-stretch text-[#1b3473] text-[15px] font-semibold">
                    {activeButton === "Classes Scheduled" &&
                      (item.progress.classes.present + item.progress.classes.absent === 0
                        ? "N/A"
                        : `${item.progress.classes.present} / ${item.progress.classes.present + item.progress.classes.absent}`)}
                    {activeButton === "Problems Solving" && item.progress.attempted}
                  </div>
                  <div className="self-stretch text-[#636363] text-xs font-medium">
                    {month !== null
                      ? `${item.name} . ${new Date(year, month, 1).toLocaleString("default", { month: "short" })}`
                      : `${new Date(year, showFirst6Months ? index : index + 6, 1).toLocaleString("default", { month: "long" })}`}
                  </div>
                </div>
              ) : (
                <div className="w-[calc(50%-4px)] p-2 gap-2 border border-[#d3d3d3] rounded-lg flex flex-col">
                  <div className="text-[#333232] text-sm font-semibold">
                    {month !== null
                      ? `${item.name} . ${new Date(year, month, 1).toLocaleString("default", { month: "short" })}`
                      : `${new Date(year, showFirst6Months ? index : index + 6, 1).toLocaleString("default", { month: "long" })}`}
                  </div>
                  <div className="w-full bg-[#d3d3d3] h-[1px]"></div>
                  <div className="flex flex-col gap-1 justify-between">
                    {activeButton === "Mentor Sessions" ? (
                      <>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Completed</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center bg-[#EDFFF2] text-[#07B42D]">
                            {item.progress?.mentorSessions?.completed}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Mentee Absent</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.mentorSessions?.menteeAbsent}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Mentor Absent</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.mentorSessions?.mentorAbsent}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Canceled-Mentor</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.mentorSessions?.cancelledByMentor}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Canceled-Mentee</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.mentorSessions?.cancelledByMentee}
                          </p>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Attempted</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#333333]">
                            {item.progress?.exams?.present}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Absent</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.exams?.absent}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Passed</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#07B42D]">
                            {item.progress?.exams?.pass}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Failed</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#DC2626]">
                            {item.progress?.exams?.fail}
                          </p>
                        </div>
                        <div className="flex justify-between text-[#646464]">
                          <p className="text-xs font-medium">Avg. Score</p>
                          <p className="text-xs font-medium w-[30px] flex justify-center text-[#333333]">
                            {item.progress?.exams?.averageScore}%
                          </p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              )
            )
          ) : (
            <>
              {activeButton === "Attendance Report" && (
                <div className="w-full flex flex-col gap-4">
                  {(!overallProgress.attendance.attendance.totalClasses ||
                    (overallProgress.attendance.attendance.attendedClasses * 100) /
                      overallProgress.attendance.attendance.totalClasses <=
                      25) && (
                    <div className="w-[100%] px-4 py-2 bg-rose-50 rounded-lg inline-flex gap-1 justify-start items-center text-red-600 text-sm font-semibold font-['Inter']">
                      <InfoButton className="w-3 h-3" color={"rgb(220 38 38 / var(--tw-text-opacity, 1))"} />
                      Inactice
                    </div>
                  )}
                  {overallProgress.attendance.attendance.totalClasses &&
                    (overallProgress.attendance.attendance.attendedClasses * 100) /
                      overallProgress.attendance.attendance.totalClasses <=
                      75 &&
                    (overallProgress.attendance.attendance.attendedClasses * 100) /
                      overallProgress.attendance.attendance.totalClasses >
                      25 && (
                      <div className="w-[100%] px-4 py-2 bg-yellow-50 rounded-lg inline-flex gap-1 justify-start items-center text-amber-400 text-sm font-semibold font-['Inter']">
                        <InfoButton className="w-3 h-3" color={"rgb(251 191 36 / var(--tw-text-opacity, 1))"} />
                        Active
                      </div>
                    )}
                  {overallProgress.attendance.attendance.totalClasses &&
                    (overallProgress.attendance.attendance.attendedClasses * 100) /
                      overallProgress.attendance.attendance.totalClasses >
                      75 && (
                      <div className="w-[100%] px-4 py-2 bg-emerald-50 rounded-lg inline-flex gap-1 justify-start items-center text-green-600 text-sm font-semibold font-['Inter']">
                        <InfoButton className="w-3 h-3" color={"rgb(22 163 74 / var(--tw-text-opacity, 1))"} />
                        Highly Active
                      </div>
                    )}
                  <div className="w-[100%] px-4 py-2 bg-stone-50 rounded-lg inline-flex flex-col gap-2.5 justify-start items-start text-stone-500 text-sm font-semibold font-['Inter']">
                    <div className="inline-flex items-center gap-[4px]">
                      <LineChartIcon className="w-3 h-3" />
                      <div>Cumulative Attendance</div>
                    </div>
                    <div className="font-medium text-xs">
                      {overallProgress.attendance.attendance.attendedClasses}/
                      {overallProgress.attendance.attendance.totalClasses}{" "}
                      {`(${Math.floor(
                        (overallProgress.attendance.attendance.attendedClasses * 100) /
                          overallProgress.attendance.attendance.totalClasses
                      )})%`}
                    </div>
                  </div>
                  <div className="w-[100%] h-[1px] bg-neutral-300" />
                  <div className="w-[100%] border border-neutral-300 px-4 py-3 rounded-lg inline-flex flex-col gap-1.5 justify-start items-start text-stone-500 text-sm font-semibold font-['Inter']">
                    <div className="w-[100%] inline-flex justify-between items-start">
                      <div>
                        Cumulative Attendance{" "}
                        {`(${Math.floor(
                          (overallProgress.attendance.attendance.attendedClasses * 100) /
                            overallProgress.attendance.attendance.totalClasses
                        )})%`}
                      </div>
                      {!(showAttendance === -1) ? (
                        <div
                          className="inline-flex justify-center items-center cursor-pointer"
                          onClick={() => {
                            setShowAttendance(-1)
                          }}
                        >
                          <ChevronDown1 />
                        </div>
                      ) : (
                        <div
                          className="inline-flex justify-center items-center cursor-pointer"
                          onClick={() => {
                            setShowAttendance(-2)
                          }}
                        >
                          <ChevronUp />
                        </div>
                      )}
                    </div>
                    {showAttendance === -1 && (
                      <div className="w-[100%] inline-flex flex-col gap-1.5 justify-start items-start text-stone-500 text-xs font-medium font-['Inter']">
                        <div className="w-full h-[1px] bg-neutral-300" />
                        <div className="w-[100%] inline-flex justify-between items-start">
                          <div>Classes Attended :</div>
                          <div>{overallProgress.attendance.attendance.attendedClasses}</div>
                        </div>
                        <div className="w-[100%] inline-flex justify-between items-start">
                          <div>Total Classes :</div>
                          <div>{overallProgress.attendance.attendance.totalClasses}</div>
                        </div>
                      </div>
                    )}
                  </div>
                  {Object.entries(overallProgress.attendance.moduleAttendance).map(([key, val], index) => (
                    <div className="w-[100%] border border-neutral-300 px-4 py-3 rounded-lg inline-flex flex-col gap-1.5 justify-start items-start text-stone-500 text-sm font-semibold font-['Inter']">
                      <div className="w-[100%] inline-flex justify-between items-start">
                        <div>
                          {key} {`(${Math.floor(((val as any).attendedClasses * 100) / (val as any).totalClasses)})%`}
                        </div>
                        {!(showAttendance === index) ? (
                          <div
                            className="inline-flex justify-center items-center cursor-pointer"
                            onClick={() => {
                              setShowAttendance(index)
                            }}
                          >
                            <ChevronDown1 />
                          </div>
                        ) : (
                          <div
                            className="inline-flex justify-center items-center cursor-pointer"
                            onClick={() => {
                              setShowAttendance(-2)
                            }}
                          >
                            <ChevronUp />
                          </div>
                        )}
                      </div>
                      {showAttendance === index && (
                        <div className="w-[100%] inline-flex flex-col gap-1.5 justify-start items-start text-stone-500 text-xs font-medium font-['Inter']">
                          <div className="w-full h-[1px] bg-neutral-300" />
                          <div className="w-[100%] inline-flex justify-between items-start">
                            <div>Classes Attended :</div>
                            <div>{(val as any).attendedClasses}</div>
                          </div>
                          <div className="w-[100%] inline-flex justify-between items-start">
                            <div>Total Classes :</div>
                            <div>{(val as any).totalClasses}</div>
                          </div>
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              )}
              {activeButton === "Class Streak" && (
                <div className="w-[100%] flex flex-col gap-4">
                  <div className="w-[100%] bg-yellow-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2.5 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <GoldMedal className="h-3 w-3" />
                      Total Coins Earned
                    </div>
                    <div className="text-amber-400 text-base font-semibold">{overallProgress.class.coins}</div>
                  </div>
                  <div className="w-[100%] bg-violet-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2.5 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <LineChartIcon className="w-3 h-3" />
                      Highest Streak
                    </div>
                    <div className="text-violet-600 text-base font-semibold">{overallProgress.class.maxStreak}</div>
                  </div>
                  <div className="w-[100%] bg-fuchsia-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2.5 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Calendar className="w-3 h-3" />
                      Most Active Month
                    </div>
                    <div className="text-fuchsia-400 text-base font-semibold">
                      {overallProgress.class.activeMonth.month}{" "}
                      {`(${overallProgress.class.activeMonth.attendancePercentage} attendance)`}
                    </div>
                  </div>
                </div>
              )}
              {activeButton === "Problems Solved" && (
                <div className="w-[100%] flex flex-col gap-4">
                  <div className="w-[100%] bg-rose-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Clock className="w-3 h-3" color={"rgb(220 38 38 / var(--tw-text-opacity, 1))"} />
                      Platform Problems
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-red-600 text-base font-semibold">{overallProgress.solved.platform}</div>
                      <div className="text-[10px]">Total Problems Solved</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-violet-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <LineChart className="w-3 h-3" />
                      Leetcode Problems
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-violet-600 text-base font-semibold">{overallProgress.solved.leetcode}</div>
                      <div className="text-[10px]">Total Problems Solved</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-fuchsia-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Calendar className="w-3 h-3" />
                      Most Active Month
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-fuchsia-400 text-base font-semibold">
                        {overallProgress.solved.mostActiveMonth}
                      </div>
                      <div className="text-[10px]">{overallProgress.solved.maxSolved} problems solved</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-cyan-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Wallet className="w-3 h-3" />
                      Batch Performance
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-cyan-400 text-base font-semibold">
                        Top {overallProgress.solved.batchPerformance}%
                      </div>
                      <div className="text-[10px]">of the batch</div>
                    </div>
                  </div>
                </div>
              )}
              {activeButton === "Problems Solved Streak" && (
                <div className="w-[100%] flex flex-col gap-4">
                  <div className="w-[100%] bg-rose-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Clock className="w-3 h-3" color={"rgb(220 38 38 / var(--tw-text-opacity, 1))"} />
                      Current Streak
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-red-600 text-base font-semibold">
                        {overallProgress.problems.streakHistory.length
                          ? overallProgress.problems.streakHistory[overallProgress.problems.streakHistory.length - 1]
                          : 0}
                      </div>
                      <div className="text-[10px]">Minimum 1 problem/day</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-violet-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <LineChart className="w-3 h-3" />
                      Longest Streak
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-violet-600 text-base font-semibold">
                        {overallProgress.problems.longestStreak} days
                      </div>
                      <div className="text-[10px]">Personal Best</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-fuchsia-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Calendar className="w-3 h-3" />
                      Most Productive Day
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-fuchsia-400 text-base font-semibold">
                        {overallProgress.problems.maxSolvedDay.month} {overallProgress.problems.maxSolvedDay.date}
                      </div>
                      <div className="text-[10px]">
                        {overallProgress.problems.maxSolvedDay.problemsSolved} problems solved
                      </div>
                    </div>
                  </div>
                  {overallProgress.solved.total <= 100 && (
                    <div className="w-[100%] bg-rose-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                      <div className="flex gap-1 items-center">
                        <Wallet className="w-3 h-3" />
                        Performance Badge
                      </div>{" "}
                      <div className="flex flex-col gap-1">
                        <div className="text-red-600 text-base font-semibold">Problem Solver</div>
                        <div className="text-[10px]">Top {overallProgress.solved.batchPerformance}% consistency</div>
                      </div>
                    </div>
                  )}
                  {overallProgress.solved.total > 100 && overallProgress.solved.total <= 200 && (
                    <div className="w-[100%] bg-emerald-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                      <div className="flex gap-1 items-center">
                        <Wallet className="w-3 h-3" />
                        Performance Badge
                      </div>{" "}
                      <div className="flex flex-col gap-1">
                        <div className="text-green-500 text-base font-semibold">Problem Prodigy</div>
                        <div className="text-[10px]">Top {overallProgress.solved.batchPerformance}% consistency</div>
                      </div>
                    </div>
                  )}
                  {overallProgress.solved.total > 200 && (
                    <div className="w-[100%] bg-cyan-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                      <div className="flex gap-1 items-center">
                        <Wallet className="w-3 h-3" />
                        Performance Badge
                      </div>{" "}
                      <div className="flex flex-col gap-1">
                        <div className="text-cyan-400 text-base font-semibold">Problem Master</div>
                        <div className="text-[10px]">Top {overallProgress.solved.batchPerformance}% consistency</div>
                      </div>
                    </div>
                  )}
                </div>
              )}
              {activeButton === "Mentor Session" && (
                <div className="w-[100%] flex flex-col gap-4">
                  <div className="w-[100%] bg-violet-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <LineChart className="w-3 h-3" />
                      Total Mentor Sessions Held
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-violet-600 text-base font-semibold">{overallProgress.mentor.total}</div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-fuchsia-100 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Calendar className="w-3 h-3" />
                      Next Session Countdown
                    </div>{" "}
                    <div className="flex flex-col gap-1">
                      <div className="text-fuchsia-400 text-base font-semibold">
                        {overallProgress.mentor.nextSession}
                      </div>
                    </div>
                  </div>
                  <div className="w-[100%] bg-cyan-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-stone-500 text-xs font-normal font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <Wallet className="w-3 h-3" />
                      Interview Readiness
                    </div>{" "}
                    <div className="text-cyan-400 text-base font-semibold">
                      {overallProgress.mentor.mentorRatings.totalRating}%
                    </div>
                    <div className="flex flex-col gap-3 text-stone-500 text-xs">
                      <div className="font-normal">
                        This score will gradually increase with the number of sessions you attend.
                      </div>
                      <div className="font-semibold">
                        Note** This score is solely dependent on the feedback received from the mentor. This score does
                        not guarantee any interview success.
                      </div>
                    </div>
                  </div>
                  <div className="w-full h-[1px] bg-neutral-300" />
                  <div className="w-[100%] bg-emerald-50 px-4 py-2 rounded-lg inline-flex flex-col gap-2 justify-start items-start text-green-600 text-xs font-semibold font-['Inter']">
                    <div className="flex gap-1 items-center">
                      <CheckBox className="w-3 h-3" />
                      Excellent Work! Keep Up The Good Work!
                    </div>{" "}
                    <div className="text-stone-500 text-xs font-normal">
                      Your consistent progress across all parameters shows great dedication to improvement. The
                      cumulative report indicates steady growth in key areas.
                    </div>
                    <div className="text-neutral-950 text-xs font-medium">
                      This is based on your last mentor session.
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </CustomScroll>
    </div>
  )
}

export default DetailedProgressDataView
